import React from "react";
import { Form, Modal, Input } from "antd";
import FormValidator, { requiredField } from "../../../../models/formValidator";

const defaultSettings = {
  formValidator: {
    username: [
      requiredField("korisničko ime"),
      { min: 3, message: "Minimalno 3 znaka" },
      { max: 20, message: "Maksimalno 20 znakova" },
      {
        validator: function(rule, value, callback) {
          if (value && (value.startsWith(" ") || value.endsWith(" "))) {
            callback("Korisničko ime ne smije početi ili završiti razmakom");
          } else {
            callback();
          }
        }
      }
    ],
    email: FormValidator.email,
    password: [
      requiredField("lozinka"),
      { min: 6, message: "Minimalno 6 znakova" }
    ],
    confirmPassword: [requiredField("ponovljena lozinka")]
  }
};

const CreateMemberPopup = ({
  form,
  onDismiss,
  settings,
  isVisible,
  loading,
  onSubmit
}) => {
  const handleCreate = () => {
    form.validateFields((error, values) => {
      if (error) return;
      if (values.password !== values.confirmPassword) {
        form.setFields({
          confirmPassword: {
            value: values.confirmPassword,
            errors: [new Error("Lozinke se ne podudaraju")]
          }
        });
        return;
      }
      onSubmit(values, (status) => {
        if (status) {
          form.resetFields();
          onDismiss();
        }
      });
    });
  };

  const handleCancel = () => {
    form.resetFields();
    onDismiss();
  };

  return (
    <Modal
      title="Kreiraj novog korisnika"
      visible={isVisible}
      onCancel={handleCancel}
      okText="Kreiraj"
      onOk={handleCreate}
      confirmLoading={loading}
    >
      <Form layout="vertical">
        <Form.Item label="Korisničko ime">
          {form.getFieldDecorator("username", {
            rules: settings.formValidator.username
          })(<Input placeholder="Korisničko ime" />)}
        </Form.Item>
        <Form.Item label="Email">
          {form.getFieldDecorator("email", {
            rules: settings.formValidator.email
          })(<Input placeholder="Email" />)}
        </Form.Item>
        <Form.Item label="Lozinka">
          {form.getFieldDecorator("password", {
            rules: settings.formValidator.password
          })(<Input.Password placeholder="Lozinka" />)}
        </Form.Item>
        <Form.Item label="Ponovite lozinku">
          {form.getFieldDecorator("confirmPassword", {
            rules: settings.formValidator.confirmPassword
          })(<Input.Password placeholder="Ponovite lozinku" />)}
        </Form.Item>
      </Form>
    </Modal>
  );
};

CreateMemberPopup.defaultProps = {
  settings: defaultSettings,
  isVisible: false,
  loading: false
};

export default Form.create()(CreateMemberPopup);



// WEBPACK FOOTER //
// ./src/routes/Admin/ManageUserPage/CreateMemberPopup/CreateMemberPopup.tsx